import { type DisplayContextsType, displayContexts } from '@openx/types/targeting/targeting.ts';
import {
  TechnologyAndDevicesOption,
  type TechnologyAndDevicesOption as TechnologyAndDevicesOptionType,
} from '@openx/types/targeting/technologyAndDevices.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomOptionsContext } from '../../../../utils/hooks/useCustomOptionsContext.tsx';
import { getTypeOptionsLabels } from '../../utils.ts';

export const useTypeOptionDropdown = (isNewFormat: boolean, displayContext: DisplayContextsType | undefined) => {
  const { t } = useTranslation();

  const customOptions = useCustomOptionsContext<TechnologyAndDevicesOptionType>();
  const labels = getTypeOptionsLabels(t, displayContext);

  const availableOptions = useMemo(() => {
    const selectedOptions = {};

    if (
      isNewFormat &&
      displayContext !== displayContexts.TRAFFIC_SET &&
      displayContext !== displayContexts.PRICING_RULE &&
      customOptions?.availableOptions
    ) {
      customOptions.availableOptions = customOptions.availableOptions.filter(
        element => element !== TechnologyAndDevicesOption.DEVICE_TYPE
      );
      customOptions.defaultOption = customOptions.availableOptions[0];
    }

    customOptions?.availableOptions.forEach(option => {
      selectedOptions[option] = labels[option];
    });

    return selectedOptions;
  }, [customOptions, labels, displayContext, isNewFormat]);

  return {
    availableOptions,
    optionsKeys: Object.keys(availableOptions) as TechnologyAndDevicesOption[],
    getOptionLabel: (option: TechnologyAndDevicesOption) => availableOptions[option],
  };
};
